import { render, staticRenderFns } from "./latestexchangeChild.vue?vue&type=template&id=3008a96b&scoped=true"
import script from "./latestexchangeChild.vue?vue&type=script&lang=js"
export * from "./latestexchangeChild.vue?vue&type=script&lang=js"
import style0 from "./latestexchangeChild.vue?vue&type=style&index=0&id=3008a96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008a96b",
  null
  
)

export default component.exports